// extracted by mini-css-extract-plugin
module.exports = {"copyrightText":"copyright-notice_copyrightText___hL1P","link":"copyright-notice_link__VOGxF","divider":"copyright-notice_divider__hGdiS"};